import { Modal, setColorTheme } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const ModalStyles = styled(Modal)`
  max-width: 40rem;
  button[data-test='data-test-cancel-button'] {
    color: ${setColorTheme('primary400')};
  }
`;
